import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { StatusBadge } from "@/components/site/StatusBadge";
import { formatPrice, imgSrc, TYPES } from "@/lib/api";

export const ProgrammeCard = ({ p, index = 0 }) => (
  <Link
    to={`/programmes/${p.id}`}
    className="group block rise"
    style={{ animationDelay: `${index * 90}ms` }}
    data-testid={`programme-card-${p.id}`}
  >
    <div className="relative aspect-[4/5] overflow-hidden rounded-sm bg-[#2F2A28]">
      {p.images?.[0] && (
        <img
          src={imgSrc(p.images[0])}
          alt={p.name}
          className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-[#1A1716]/90 via-[#1A1716]/10 to-transparent" />
      <div className="absolute top-4 left-4"><StatusBadge status={p.status} /></div>
      <div className="absolute bottom-0 inset-x-0 p-6 text-white">
        <p className="text-xs uppercase tracking-[0.2em] text-white/60 flex items-center gap-1.5">
          <MapPin className="h-3.5 w-3.5" /> {p.city} · {TYPES[p.type]}
        </p>
        <h3 className="font-display text-3xl mt-2 leading-tight">{p.name}</h3>
        <div className="mt-4 flex items-center justify-between">
          <span className="text-[#D4A373] text-sm font-medium">{formatPrice(p.price, p.price_from)}</span>
          <span className="h-10 w-10 rounded-full border border-white/30 grid place-items-center transition-colors duration-300 group-hover:bg-[#C88A58] group-hover:border-[#C88A58]">
            <ArrowUpRight className="h-4 w-4" />
          </span>
        </div>
      </div>
    </div>
  </Link>
);
